module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "logo_light.81e728f6.png" + "?" + Date.now();